module.exports = __webpack_public_path__ + "static/img/7.ad4c9f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/7.png
// module id = DETw
// module chunks = 0